// animate
import Lottie from 'react-lottie';
import animationData from '../../assets/animation/loading.json';

const Loading = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    return (
        <>
            <article className={'container h-100'}>
                <div className={'row h-100 align-items-center justify-content-center'}>
                    <div className={'col-md-4 col-12'}>
                        <Lottie
                            options={defaultOptions}
                            width={150}
                            height={150}
                        />
                    </div>
                </div>
            </article>
        </>
    )
}

export default Loading